import { createActions } from 'redux-actions';

import { BenefitTemplateList } from '@models/BenefitTemplate';

export type State = {
  benefitTemplates: BenefitTemplateList[];
};

export type StateUpdatePayload = Partial<State>;

export const {
  benefitTemplatesFetch,
  stateUpdate,
} = createActions(
  'BENEFIT_TEMPLATES_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_BENEFIT_TEMPLATE',
  },
);
